import React, { useState, useEffect } from "react";
import "./OurLessons.css";
import "./../typography-home.css";
import { useNavigate } from "react-router-dom";
import heroImg from "../../../assets/HomeSection/homeMain-image-01.png";
import { useSelector } from "react-redux";
import {
  englishData,
  sinhalaData,
  tamilData,
} from "../../../dummyData/HomeDummyData";

function OurLessons() {
  const navigate = useNavigate();
  const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(sinhalaData[0]);

  useEffect(() => {
    switch (selectedLanguage.value) {
      case "english":
        setLanguage(englishData[0]);
        break;
      case "tamil":
        setLanguage(tamilData[0]);
        break;
      default:
        setLanguage(sinhalaData[0]);
        break;
    }
  }, [selectedLanguage]);

  const handleOpenAcademy = () => {
    navigate("/driving-license-video-guide");
  };

  return (
    <section className="lesson-section py-5 min-vh-75 d-flex align-items-center">
      <div className="container">
        <h2 className="typography-title text-center fw-bold mb-3">
          {language.LessonsTitle}
        </h2>

        <div className="row align-items-center justify-content-center lesson-row">
          {/* Video Thumbnail */}
          <div className="col-md-6 col-12 mb-4 mb-md-0 text-center">
           <div className="video-wrapper">
  
  <iframe
    className="lesson-video"
    src="https://app.videas.fr/embed/media/6c1f6fd4-1c6b-4134-97a5-bfb837030197/"
    title="Driving License Lessons"
    frameBorder="0"
    allow="autoplay; fullscreen; picture-in-picture"
    allowFullScreen
  ></iframe>
</div>

          </div>

          {/* Lesson Description */}
          <div className="col-md-6 col-12 ps-lg-5 ps-xs-0 ps-sm-0 ps-2  d-flex flex-column justify-content-between h-100">
            <h3 className="fw-bold mb-3 typography-subtitle text-center text-md-start">
              {language.LessonsSubTitle}
            </h3>

            <p className="text-muted mb-3 text-justify typography-paragraph text-center text-md-start">
              {language.LessonsDescription}
            </p>

            <button
              className="btn btn-danger px-4 py-2 fw-semibold our-lessons-btn mt-3 align-self-md-start align-self-center"
              onClick={handleOpenAcademy}
            >
              {language.LessonsBtn}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurLessons;
